import {FormEvent,useState} from 'react';
import {OrderPrintingPanel} from '../components/OrderPrintingPanel.tsx';
import type {SmtPrintingPort} from '../smt-printing-port.ts';

export function PrintOperationsPage({runtime}:{runtime:SmtPrintingPort}){
  const [orderIdInput,setOrderIdInput]=useState('');
  const [orderId,setOrderId]=useState<string|null>(null);
  const [message,setMessage]=useState<string|null>(null);

  const submit=(event:FormEvent)=>{
    event.preventDefault();
    const next=orderIdInput.trim();
    if(!next){setMessage('請輸入訂單號');return;}
    setMessage(null);
    setOrderId(next);
  };

  return <main className="print-ops-page">
    <section className="panel print-ops-hero">
      <div><p className="eyebrow">SMT · C REQ-13</p><h1>設備／打印</h1><p>目前只接通<strong>訂單打印語義</strong>：打印狀態、明確補印、failed 重試。打印機在線、IP、USB、Sunmi、slot/binding 仍由 A Native/Hardware 負責，呢個畫面唔會自行推斷。</p></div>
      <span className="print-ops-ceiling">Transport ≠ 出紙</span>
    </section>

    <section className="panel print-ops-search" aria-label="選擇訂單打印">
      <form onSubmit={submit}>
        <label><span>訂單號</span><input value={orderIdInput} onChange={event=>setOrderIdInput(event.target.value)} placeholder="輸入 Order ID"/></label>
        <button type="submit">讀取打印工作</button>
      </form>
      {message?<div className="print-ops-form-message" role="status">{message}</div>:null}
      {!orderId?<p className="print-ops-helper">輸入訂單號後，畫面會直接讀取 C Print Authority 嘅 order-scoped snapshot。</p>:null}
    </section>

    {orderId?<OrderPrintingPanel runtime={runtime} orderId={orderId}/>:null}
  </main>;
}
